import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FeatureFlagService } from '@app/core/services/feature-flag.service';
import { NetworkStatusService } from '@app/core/services/network-status.service';
import { UserService } from '@app/core/services/user.service';
import { FeatureFlagKey } from '@dwo/enums';

@Injectable({ providedIn: 'root' })
export class AdminV2Guard implements CanActivate, CanActivateChild {
  constructor(
    private userService: UserService,
    private featureFlags: FeatureFlagService,
    private networkStatus: NetworkStatusService,
    private router: Router,
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const denied = this.router.createUrlTree(['/error/404']);
    try {
      if (!(await firstValueFrom(this.networkStatus.isOnline()))) return denied;
      const user = await firstValueFrom(this.userService.getCurrentUser());
      if (user?.admin !== true) return denied;
      if (!(await this.featureFlags.refresh(user.email || user.username))) return denied;
      return this.featureFlags.isEnabled(FeatureFlagKey.EnableNewAdmin) ? true : denied;
    } catch {
      return denied;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.canActivate(route, state);
  }
}
